import { Injectable } from '@angular/core';
import { AuthService } from 'app/src/app/core/services/auth.service';
import { InstallerDsService } from 'lib/src/datastore/installer-ds.service';
import { SettingDsService } from 'lib/src/datastore/setting-ds.service';
import { LibService } from 'lib/src/lib/lib.service';
import { Settings } from 'lib/src/models/settings.model';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private isAppReady = new BehaviorSubject<boolean>(false);
  public isAppReady$ = this.isAppReady.asObservable();

  public _isOnline = new BehaviorSubject<boolean>(true);
  public isOnline$ = this._isOnline.asObservable();

  public isLightTheme = new BehaviorSubject<boolean>(true);
  public isLightTheme$ = this.isLightTheme.asObservable();
  public installers$ = this.installerDsService.getAll$().pipe(shareReplay(1));
  public generalSettings!: Settings.General;
  public user$ = this.authService.user$;


  constructor(
    private installerDsService: InstallerDsService,
    private settingDsService: SettingDsService,
    private connectionService: ConnectionService,
    private authService: AuthService


  ) {
    this.connectionService.monitor().subscribe(v => this._isOnline.next(v.hasInternetAccess))

  }
  async init(){
    console.log("Initttttt->")

    //this.generalSettings = await this.settingDsService.get$('general').pipe(take(1)).toPromise() as Settings.General;
    this.user$.subscribe(user=>{
      console.log("user", user)
      // if (user && user.id && user.createdAt){ //coloamos createdAt para asegurarnos que son datos que vienen del servidor y no de caché
      if (user && user.id){ //coloamos createdAt para asegurarnos que son datos que vienen del servidor y no de caché

        this.isAppReady.next(true);
      }else{
        this.isAppReady.next(false);
      }
    })
  }

  toggleTheme(){
    this.isLightTheme.next(!this.isLightTheme.value);
  }
}
